import React, { FunctionComponent } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAppSelector } from 'app/hooks';
import { SessionState } from 'features/session/sessionSlice';
import { useMediaQuery } from 'react-responsive';

import SideBar from './SideBar';
import styles from './SideBar.module.scss';

const UserDashboardLayout: FunctionComponent = () => {
  const { logged } = useAppSelector(({ session }: { session: SessionState }) => session);
  if (!logged) {
    return <Navigate to="/" replace />;
  }
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className="h-100 container-fluid">
      <main className="row h-100">
        {!isMobile && (
          <div className="h-100 col-md-4 col-lg-3 col-xxl-2">
            <SideBar />
          </div>
        )}
        <section className={`col-md-8 col-lg-9 col-12 col-xxl-10 ${styles.outlet}`}>
          <Outlet />
        </section>
      </main>
    </div>
  );
};

export default UserDashboardLayout;
